'use es6';

import { formatToReferencesList } from 'reference-resolvers/lib/formatReferences';
export const formatCommentCounts = (commentsPerAsset, objectType) => formatToReferencesList({
  getId: item => item.id,
  getLabel: item => `${item.total}`
})(Object.keys(commentsPerAsset).map(id => ({
  id: `${id}&${objectType}`,
  total: commentsPerAsset[id].total
})));